import firebase from 'firebase/app';
import { FirestoreTimestamp } from 'services/hitchit/types/shared/FirestoreTimestamp';

/**
 * @param aDate This is in reality a firebase date
 * @returns
 */
export default function firebaseToDate(aDate?: FirestoreTimestamp | Date): Date | undefined {
  if (!aDate) {
    return;
  }

  if (!(aDate as FirestoreTimestamp)._seconds) {
    return aDate as Date;
  }

  const firestoreTimestamp = aDate as FirestoreTimestamp;

  return new firebase.firestore.Timestamp(
    firestoreTimestamp._seconds,
    firestoreTimestamp._nanoseconds
  ).toDate();
}

/**
 * @param aDate This is in reality a firebase date
 * @returns
 */
export function dateToFirebase(aDate?: Date): FirestoreTimestamp | undefined {
  if (!aDate) {
    return;
  }

  return firebase.firestore.Timestamp.fromDate(aDate) as unknown as FirestoreTimestamp;
}
